var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowDropDown = function SvgArrowDropDown(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "m16.297 10.385-3.694 4.333a.787.787 0 0 1-1.207 0l-3.694-4.333C7.245 9.847 7.614 9 8.307 9h7.387c.692 0 1.062.847.603 1.385Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDropDown);
export default ForwardRef;